import { ScaleProps, useScaleProps } from '../../utils/scaleUtils'
import { MediaPDF, MediaPDFProps } from '../base'

export interface Props extends ScaleProps<MediaPDFProps> {}

export default function SMediaPDF({ mediaId, ...props }: Props) {
  const { styleProps, rest } = useScaleProps(props)
  const { w, h } = styleProps
  const dimensions = { height: h, width: w }
  return <MediaPDF mediaId={mediaId} {...dimensions} {...rest} />
}
